export var Labels = {
    useHomeAsBillingAddress: 'Alamat pengebilan adalah sama dengan alamat pada pelan mudah alih saya',
    addressLine1: '	Alamat Baris 1',
    addressLine2: 'Alamat Baris 2',
    city: '	Bandar',
    state: 'Negeri',
    zipCode: 'Poskod'
};
export var FieldErrors = {
    invalidAddressLine1: 'Sila masukkan alamat yang sah',
    invalidCity: 'Sila masukkan bandar yang sah',
    invalidState: 'Sila pilih negeri yang sah',
    invalidZipCode: 'Sila masukkan poskod yang sah'
};
export var States = [
    { name: 'Johor', value: 'Johor' },
    { name: 'Kedah', value: 'Kedah' },
    { name: 'Kelantan', value: 'Kelantan' },
    { name: 'Kuala Lumpur', value: 'Kuala Lumpur' },
    { name: 'Labuan', value: 'Labuan' },
    { name: 'Melaka', value: 'Melaka' },
    { name: 'Negeri Sembilan', value: 'Negeri Sembilan' },
    { name: 'Pahang', value: 'Pahang' },
    { name: 'Perak', value: 'Perak' },
    { name: 'Perlis', value: 'Perlis' },
    { name: 'Pulau Pinang', value: 'Pulau Pinang' },
    { name: 'Putrajaya', value: 'Putrajaya' },
    { name: 'Sabah', value: 'Sabah' },
    { name: 'Sarawak', value: 'Sarawak' },
    { name: 'Selangor', value: 'Selangor' },
    { name: 'Terengganu', value: 'Terengganu' }
];
